import React from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import Cookie from 'js-cookie';
import { loginTypes } from 'config/loginTypes';
import { gameRunningStatuses } from 'config/gameRunningStatuses';
import { loginTypeMappingPointRoutesParam } from 'config/loginTypes';
import DialogLogin from 'client/components/dialogLogin/DialogLogin';

function DialogLoginContainer({ open, onClose }) {
    const {
        settingPromo: { loginMethod },
        sponsor: { privacyUrl, privacyText }
    } = useSelector(s => s);

    const { isNeedEnterPasscode } = useSelector(s => s.userEntryState);
    const { gameRunningStatus, isTestMode } = useSelector(s => s.promoState);
    const isPromoEnd = gameRunningStatus === gameRunningStatuses.END;
    const needPasscodeHint = isNeedEnterPasscode ? i18n.t('label.passcode_need_hint') : '';
    const [title, footer] = (() => {
        if (isTestMode) {
            return [i18n.t('label.test_mode'), needPasscodeHint];
        }
        if (isPromoEnd) {
            return [i18n.t('label.promo_is_end'), i18n.t('label.login_check_prize')];
        }
        return [i18n.t('label.promo_login'), needPasscodeHint];
    })();

    if (!shouldShowLoginDialog(loginMethod)) {
        return null;
    }
    if (open) {
        // 5 min for cookie expired
        const loginType = loginTypeMappingPointRoutesParam[loginMethod];
        Cookie.set('gtm_login_event', loginType[0], { expires: 1 / (24 * 12) });
    }
    return (
        <DialogLogin
            open={open}
            title={title}
            footer={footer}
            type={loginMethod}
            handleClose={onClose}
            privacyUrl={privacyUrl}
            privacyText={privacyText}
        />
    );
}

export default DialogLoginContainer;

function shouldShowLoginDialog(loginType) {
    return new Set([
        loginTypes.FACEBOOKLOGIN,
        loginTypes.LINELOGIN,
        loginTypes.ENTERPRISELOGIN
    ]).has(loginType);
}
